import TypologyLink from "./TypologyLink";

export default TypologyLink;
